import { colors, medias } from 'assets/styled/tokens';
import styled from 'styled-components';

export const ImageUploadContainer = styled.div`
  position: relative;
  max-width: 468px;
  min-width: fit-content;
  height: 32px;
  border: 2px solid #cccccc;
  border-radius: 3px;
  padding: 8px;
  text-align: center;
  cursor: pointer;
  display: flex;
  justify-content: center;
  align-items: center;
  @media (min-width: ${medias.desktopSm}) {
    position: relative;
    max-width: 468px;
    width: 200px;
    height: 200px;
    border: ${props => (props.borderDashed ? '2px dashed #cccccc' : '2px solid #cccccc')};
    border-radius: 3px;
    padding: 20px;
    text-align: center;
    cursor: pointer;
    display: flex;
    justify-content: center;
    align-items: center;
  }
`;
export const Wrapper = styled.div`
  //margin: 0 10px;
  display: flex;
  position: relative;
  flex-direction: column;
  h5 {
    font-family: Roboto;
    font-size: 14px;
    font-weight: 400;
    line-height: 16px;
    text-align: left;
    color: #888888;
    margin-bottom: 12px;
    position: absolute;
    top: -38px;
    left: ${props => (props.isRequired ? '225px' : '210px')};
  }
  h6 {
    font-family: Roboto;
    font-size: 14px;
    font-weight: 400;
    line-height: 16px;
    text-align: left;
    color: #888888;
    margin-bottom: 18px;
    //position: absolute;
  }
  div {
    display: flex;
    flex-direction: column;
    @media (min-width: ${medias.desktopSm}) {
      flex-direction: row;
    }
  }
`;
export const InputLabel = styled.div`
  font-family: Roboto;
  font-size: 14px;
  font-weight: 700;
  line-height: 20px;
  text-align: left;
  color: #1e1e1e;
`;
export const Input = styled.input`
  display: none;
`;
export const MobileLabel = styled.label`
  display: flex;
  font-family: Roboto;
  font-weight: 700;
  font-size: 14px !important;
  line-height: 20px;
  margin-bottom: 0 !important;
  letter-spacing: 0.3px;
  color: #1e1e1e;
  justify-content: space-evenly;
  align-items: center;
  gap: 12px;
  @media (min-width: ${medias.desktopSm}) {
    display: none;
  }
`;
export const Label = styled.label`
  display: none;
  @media (min-width: ${medias.desktopSm}) {
    font-family: Roboto;
    position: absolute;
    color: #7f746a;
    font-weight: 400;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    cursor: pointer;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    height: 40%;
    width: 100%;
    font-size: 14px !important;
    padding: 0 25px;
    div:first-of-type {
      display: flex;
      flex-direction: row;
      justify-content: center;
    }
  }
`;

export const SubLabel = styled.b`
  font-weight: normal;
  text-decoration: underline;
  display: block;
  cursor: pointer;
  font-size: 12px !important;
  margin: 0 0 0 5px !important;
  font-weight: 500;
  color: ${colors.primary};
`;
export const SubLabelWrapper = styled.span`
  display: flex;
  justify-content: center;
`;
export const PreviewImage = styled.img`
  max-width: 100%;
  max-height: 100%;
  object-fit: contain;
  @media (min-width: ${medias.desktopSm}) {
    //width: 260px;
    //height: 260px;
  }
`;
export const ButtonContainer = styled.div`
  display: flex;
  justify-content: flex-end;
  margin-top: 10px;
  max-width: 468px;
`;

export const ButtonTrash = styled.button`
  background-color: #fff;
  color: white;
  border: none;
  padding: 5px 10px;
  cursor: pointer;
  margin-left: 5px;
  border-radius: 3px;
`;
export const Button = styled.button`
  position: absolute;
  top: 0px;
  right: 0px;
  background: ${colors.primary};
  border: none;
  border-radius: 4px;
  width: 24px;
  height: 24px;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;

  &:hover {
    background: rgba(255, 0, 0, 0.8);
  }

  svg {
    width: 16px;
    height: 16px;
    fill: #000;

    &:hover {
      fill: #fff;
    }
  }
  @media (min-width: ${medias.desktopSm}) {
  }
`;

export const InputColumn = styled.div`
  display: flex;
  flex-direction: row !important;
  justify-content: space-between;
  height: auto;
  gap: 20px;
  margin-right: 25px;
  @media (min-width: ${medias.desktopSm}) {
    flex-direction: column !important;
  }
`;
export const PreviewImagesContainer = styled.div`
  display: flex;
  gap: 11px;
  margin-top: 20px;
  //flex-wrap: wrap;
  //margin-top: 40px;
  width: auto;
  height: auto;
  flex-direction: row !important;
  div {
    background-color: #eae8e5;
    position: relative;
    display: flex;
    justify-content: center;
    align-items: center;
    width: ${props => props.fotosSize};
    height: ${props => props.fotosSize};
    border-radius: 4px;
    //border: 2px solid #bbbbbb;
  }
  @media (min-width: ${medias.desktopSm}) {
    flex-direction: row;
    width: 100%;
    height: auto;
    gap: 24px;
    margin-top: 0;
    div {
      width: 200px;
      height: 200px;
    }
  }
`;
export const FindImageButton = styled.button`
  width: 145px;
  height: 24px;
  border-radius: 4px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 2px 4px;
  border: 1px solid #f38a00;
  color: #f38a00;
  background-color: #fff;
  font-family: Roboto;
  font-weight: 700;
  font-size: 14px;
  line-height: 20px;
  letter-spacing: 0.3px;
`;
export const ErrorText = styled.div`
  font-family: Roboto;
  font-size: 14px;
  font-weight: 400;
  line-height: 20px;
  text-align: left;
  color: #c25446;
  margin-bottom: 12px;
  margin-top: 10px;
`;
